import type { ReactElement } from 'react';
import type { FormFieldTypeId } from '@witmetrics/utils';
import { FIELD_TYPE_ID } from '@witmetrics/utils/constants';
import {
  ArrowDownIcon,
  type BaseIconProps,
  BooleanIcon,
  CalendarIcon,
  CheckIcon,
  LongTextIcon,
  RadioInputIcon,
  ShortTextIcon,
} from '@/icons';

export const FIELDS: Record<
  FormFieldTypeId,
  (props: BaseIconProps) => ReactElement
> = {
  [FIELD_TYPE_ID.TEXT]: ShortTextIcon,
  [FIELD_TYPE_ID.LONGTEXT]: LongTextIcon,
  [FIELD_TYPE_ID.SELECT]: ArrowDownIcon,
  [FIELD_TYPE_ID.BOOLEAN]: BooleanIcon,
  [FIELD_TYPE_ID.CHECKBOX]: CheckIcon,
  [FIELD_TYPE_ID.RADIO]: RadioInputIcon,
  [FIELD_TYPE_ID.DATE]: CalendarIcon,
  [FIELD_TYPE_ID.DATETIME]: CalendarIcon,
};
